export enum ThemeType {
  CUSTOMIZED_LIVEPOLL = 1,
  CUSTOMIZED_USER_NAMED = 2,
}
